"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 *
 * @param {number} number
 * Formats the price to have the dollar sign and
 * if the value is a whole number it adds the 2 decimal places
 */
var FormatPrice = function FormatPrice(number) {
  var formattedPrice = '$' + parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return formattedPrice;
};

var _default = FormatPrice;
exports["default"] = _default;